<template>
    <span class="d-inline-block text-center" style="width: 20px">
        <feather-icon v-if="field" icon="StarIcon" size="16" class="text-warning filled-star" />
        <feather-icon v-else icon="MinusIcon" size="16" class="text-muted" style="opacity: 0.5" />
    </span>
</template>

<script>
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";

export default {
    name: "FeaturedBadge",
    components: {
        FeatherIcon,
    },
    props: {
        field: {
            type: Boolean,
            default: false,
        },
        row: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>

<style scoped>
.filled-star {
    fill: #ff9f43;
}
</style>
